
import LEVELS from './Levels';

function LevelSelect() {
    return (
        <div className="level-select-wrap">
            <label htmlFor="Lvl_select" className="level-label">Choose Your Level</label>
            <select
                id="Lvl_select"
                className="level-dropdown"
                defaultValue="1"
                onChange={() => ChangeLevel(document.getElementById("Lvl_select").value)}
            >
                {LEVELS.map((lvl) => (
                    <option key={lvl.id} value={lvl.id}>
                        {"Lv." + lvl.id + " · " + lvl.name + " — " + lvl.difficulty}
                    </option>
                ))}
            </select>
        </div>
    );
}

function ChangeLevel(levelId) {
    ///////////Reset Display///////////
    document.getElementById('game_alert').innerHTML = "";
    document.getElementById('game_alert').className = "alert_class_hidden";
    document.getElementById("score").innerHTML = "000";
    document.getElementById("timer").innerHTML = ("00:00");
    for (let id of window.all_act_ids) {
        document.getElementById(id).className = "box";
    }
    for (let id of window.obstacle_pattern) {
        document.getElementById(id).className = "box";
    }
    ///////////////////////////////////

    const level = LEVELS.find((l) => l.id === Number(levelId)) || LEVELS[0];
    window.obstacle_pattern = level.pattern;
    window.level_speed = level.speed;
    window.current_level = level.id;

    for (let id of window.obstacle_pattern) {
        document.getElementById(id).className = "obstacle_box";
    }

    const badge = document.getElementById('level_badge');
    if (badge) {
        badge.innerHTML = "Lv." + level.id + " · " + level.name;
    }
}

export default LevelSelect;
export { ChangeLevel };
